import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from './Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/FantasyTeamView.css';

const ClutchPickView = ({ parsedClutchPick, isPremium, onSelect }) => {

    // Countdown state for 5 hours before expireDate
    const [countdown, setCountdown] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        let interval;
        if (parsedClutchPick?.expireDate) {
            const updateCountdown = () => {
                const expire = new Date(parsedClutchPick.expireDate);
                const fiveHoursBefore = new Date(expire.getTime() - 5 * 60 * 60 * 1000);
                const now = new Date();
                const diff = ((isPremium ? expire : fiveHoursBefore) - now);
                if (parsedClutchPick?.isCompleted) {
                    setCountdown('Completed');
                } else if (diff <= 0) {
                    setCountdown('Expired');
                } else {
                    const hours = Math.floor(diff / (1000 * 60 * 60));
                    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
                    setCountdown(`${hours}h ${minutes}m ${seconds}s`);
                }
            };
            updateCountdown();
            interval = setInterval(updateCountdown, 1000);
        } else {
            setCountdown('Not available');
        }
        return () => clearInterval(interval);
    }, [parsedClutchPick?.expireDate]);

    const handleClick = () => {
        if (onSelect) onSelect(parsedClutchPick);
    };

    return (
        <div className='clutch-pick-menu-container' onClick={handleClick} style={{ cursor: onSelect ? 'pointer' : undefined }}>
            <div className='teamWinner-title-wrapper'>
                {parsedClutchPick.user?.username ? (
                    <h1 className='title-events'>
                        <span
                            className='title-username-clickable'
                            onClick={(e) => {
                                e.stopPropagation();
                                const user = parsedClutchPick?.user;
                                if (user && user.userNumber) {
                                    navigate(`/profile/${user.userNumber}`);
                                } else {
                                    console.error('userNumber not found for user:', user);
                                }
                            }}
                        >
                            {parsedClutchPick && parsedClutchPick.user && parsedClutchPick.user.username}
                        </span>
                        {parsedClutchPick && parsedClutchPick.user && parsedClutchPick.user.username &&
                            <><span style={{ fontFamily: "fantasy" }}>'</span>s</>}
                        " Pack"
                    </h1>
                ) : (
                    <h1 className='title-events'>Clutch Pick</h1>
                )}
                <div className='teamWinner-info'>
                    <div className='teamWinner-box' style={{ width: '8vw' }}>
                        {countdown}
                    </div>
                </div>
            </div>

            <div className="fantasyTeamView-content">
                {countdown === 'Expired' && !parsedClutchPick.isCompleted && (<div className="clutch-pick-expired-message">
                    Expired
                </div>)}
                {parsedClutchPick && parsedClutchPick.isCompleted && (
                    <div className="clutch-pick-expired-message">
                        Completed
                    </div>
                )}
                <div className="event-fantasy-team-container clutch-pick-hoverable" onClick={handleClick}>
                    {parsedClutchPick && parsedClutchPick.players && parsedClutchPick.players.length > 0 ? (
                        <div className="cards-container">
                            {parsedClutchPick.players.map((player, index) => {
                                const selectedPlayerId = parsedClutchPick.selectedPlayer?._id || parsedClutchPick.selectedPlayer;
                                const playerId = player?._id || player;

                                // If selectedCard is missing but selectedPlayer matches, highlight the player
                                if (
                                    selectedPlayerId &&
                                    String(selectedPlayerId) === String(playerId)
                                ) {
                                    return (
                                        <div key={index} className='event-fantasy-player highlighted-card'>
                                            <div>
                                                <Card parsedPlayer={player} />
                                            </div>
                                        </div>
                                    );
                                }

                                // Otherwise, show the player as usual
                                return (
                                    <div key={index} className='event-fantasy-player'>
                                        <div>
                                            <Card parsedPlayer={player} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <p className='no-cards'>No clutch pick found</p>
                    )}
                </div>
            </div>
        </div >
    );
};

export default ClutchPickView;
